window.addEventListener('DOMContentLoaded', function () {
  console.log('ally start');

  $("#headerContainer h1.h1").attr("role", "none");

  $("ul.nav-dropdown-wrapper li.showcase-col .nav-col-right a .nav-product-title").attr({
    role: "heading",
    "aria-level": "2"
  });
  $("ul.nav-dropdown-wrapper li.showcase-col .nav-col-right a h4.nav-subtitle").attr({
    role: "heading",
    "aria-level": "3"
  });

  $("#headerContainer div.nav-icons a").attr("role", "button");

  $("a.footer-logo-image img").attr("alt", "Talitha Coffee Hope Rosted logo");
  $("div.phone-number img").attr("alt", "phone");

  $("#sticker-sections--26411595989311__call-to-action .sticker-image.rotate-anim img")
    .attr("alt", "Talitha Coffee Hope Rosted Get 10 Off");

  $(".sticker-translate-container .sticker-image img").attr("alt", "");

  $('img[src*="Section.png"]').attr("alt", "This is hope roasted");

  $('img[src*="LOGO-01.png"]').attr("alt", "Real simple logo");
  $('img[src*="LOGO-02.png"]').attr("alt", "perfect daily grind logo");
  $('img[src*="LOGO-03.png"]').attr("alt", "Daily coffee news by roast magazine logo");
  $('img[src*="LOGO-04.png"]').attr("alt", "Modern luxury san diego logo");
  $('img[src*="LOGO-05.png"]').attr("alt", "San diego logo");
  $('img[src*="LOGO-06.png"]').attr("alt", "PYMNTS logo");
  $('img[src*="LOGO-07.png"]').attr("alt", "Impact foundation logo");
  $('img[src*="LOGO-08.png"]').attr("alt", "Roastlove logo");

  $(".ecom-swiper-wrapper").attr("role", "list");
  $(".ecom-swiper-wrapper .ecom-swiper-slide").attr("role", "listitem");
  setTimeout(()=>{
$('form.g-container').each(function () {
    if (!$(this).find('.required_message').length) {
        $(this).prepend('<div class="required_message">Fields marked with * are required.</div>');
    }
});
$('#slideshow-template--25396253819199__aac0e69b-0cf2-4c43-bb45-6c8dfc204084 button.splide__arrow--prev,#slideshow-template--25396253819199__aac0e69b-0cf2-4c43-bb45-6c8dfc204084 button.splide__arrow--next').attr('disabled','');
$('.product-container-main .tasting-notes-wrapper .tasting-note').attr('role','listitem');
$(function () {
  $("a").filter(function () {
    return $.trim($(this).text()) === "" && $(this).children().length === 0;
  }).remove();
});

  },2500);
$('.product-container-main .tasting-notes-wrapper').attr('role','list');
$('.product-container-main .tasting-notes-wrapper .tasting-note').attr('role','listitem');
$('.product-container-main .tasting-notes-wrapper span.tasting-note').each(function () {
    $(this).replaceWith(
        $('<div>', {
            class: this.className,
            html: $(this).html()
        }));});
$(document).on('click keydown', '#shipping-dropdown .attr-value.attr-arrow', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return;}
    if (e.type === 'keydown') {
        e.preventDefault();}
    const $trigger = $(this);
    const isExpanded = $trigger.attr('aria-expanded') === 'true';
    $trigger.attr('aria-expanded', !isExpanded);});
// $('#shopify-section-template--25396251328831__feature_text_p996hq .font-heading p').attr({'role':'heading','aria-level':'2'});
  $(".blog-post-card-inner h4").attr({
    role: "heading",
    "aria-level": "2"
  });

 $(document).on('click', '.collection-tabs-mobile .dropdown-trigger', function () {
  const $this = $(this);

  requestAnimationFrame(() => {
    const isOpen = $this.closest('.collection-tabs-mobile').hasClass('is-open');

    $this.attr('aria-expanded', isOpen ? 'true' : 'false');
  });
});

  $("#headerContainer a#search-modal-btn").attr("aria-expanded", "false");
  $("#headerContainer a#search-modal-btn").on("click", function () {
    const isExpanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", !isExpanded);
  });

  $(".adev-cl__sidebar .adev-cl__nav").attr("aria-label", "Side");

  setTimeout(function(){
    $("form.cart__contents ul li").each(function () {
      const $text = $(this).find(".col-span-2 a p.text-sm").text().trim();
      const $img = $(this).find(".col-span-1 a img");
      const $anchor = $(this).find(".col-span-1 a.block");
      const $price = $(this).find(".col-start-4");
      $anchor.removeAttr("tabindex").removeAttr("aria-hidden");
      $img.attr("alt", "Image of product " + $text);
      $price.attr("aria-live", "polite");
      
    });

    $('form.g-container').each(function () {
      $(this).prepend('<div class="required_message">Fields marked with * are required.</div>');
    });

    if (window.location.pathname === "/" || window.location.pathname === "/index.html") {
      if (!document.title.startsWith("Homepage | ")) {
        document.title = "Homepage | " + document.title;
      }
    }

    $('video img[src*="8d5a9f5bb02d4cf8899f1b1c7a147490.thumbnail.0000000000_2000x.jpg"]').attr("alt", "");
    $('.page-liberty-public-market iframe[height="450"]').attr("aria-label", "Google maps");
$('.page-bankers-hill  iframe[height="450"]').attr("aria-label", "Google maps");

$(".page-accessibility h1.text-center.font-heading").remove();

$('.page-clairemont iframe[height="450"]').attr("aria-label", "Google maps");
  }, 1000);
 $('#section-template--25396251394367__7d04653d-97f7-4144-ba4a-9cbe3c5630ef h2.font-heading').attr({'role':'heading','aria-level':'1'});
 $('#shopify-section-template--25396251164991__14528820-54c0-40da-b52e-157fd83f8a8a .scrollHalf__group__content .title-scroll').attr({'role':'heading','aria-level':'2'});
 $('#shopify-section-template--25396254835007__product-grid .product-tile').each(function () {
    const productName = $(this).find('h3').text().trim();
    const price = $(this).find('.price-item--regular').first().text().trim();
    $(this).find('a').attr(
        'aria-label',
        `${productName}, Regular price ${price}`);});
  
  $("dl.text-right.items-center").attr("role", "none");
  $('.featured-collection button.splide__arrow--prev span img,.featured-collection button.splide__arrow--next span img').attr('alt','');

  $(".blog-section ul.splide__list li").each(function () {
    const $img = $(this).find(".media-content img");
    $img.attr("alt", "");
  });
const textarea = document.getElementById('CartSpecialInstructions');
if (textarea) {
  new MutationObserver(() => {
    if (textarea.disabled) {
      textarea.disabled = false;
      textarea.focus();
    }
  }).observe(textarea, {
    attributes: true,
    attributeFilter: ['disabled']
  });
}

  $(".adev-alert.adev-alert-error").attr({"role": "alert","aria-atomic":"true"});

  $('img[src*="2023_Talitha_Labels_Single_Origin_-_12_-_Sabanilla_1_2_400x.progressive.svg.jpg"]')
    .attr("alt", "Ignite signature blend organic tasting notes bittersweet cocos, burnt sugar, rich dark roast level");

  $('img[src*="/2023_Talitha_Labels_Single_Origin_-_12_-_Sabanilla_1_1_400x.progressive.svg.jpg?v=1706186262"]')
    .attr("alt", "Virtuosa signature blend tasting notes dark chocolate, blackberry, roasted almond medium roast level");

  $('img[src*="2023_Talitha_Labels_Single_Origin_-_12_-_Sabanilla_1_400x.progressive.svg.jpg?v=1706094850"]')
    .attr("alt", "Bestseller arise signature blend organic tasting notes baker's chocolate, walnut, molasses medium roast level");

  $(".scrollHalf .scrollHalf__group img").attr("alt", "");
new MutationObserver(() => {
  document.querySelectorAll('#rebuy-cart .rebuy-cart__progress-bar-meter-fill')
    .forEach(el => el.removeAttribute('tabindex'));
}).observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['tabindex']
});
  $(".splide__track--loop ul.splide__list li").each(function () {
    const $pname = $(this).find(".product-tile h3").text().trim();
    const $pbtn = $(this).find("button[data-tc-qty-plus]");
    const $pInput = $(this).find("input.tc-qty-input");
    const $mbtn = $(this).find("button[data-tc-qty-minus]");

    $pbtn.attr("aria-label", "Increase " + $pname + " Quantity");
    $pInput.attr("aria-label", $pname + " Quantity");
    $mbtn.attr("aria-label", "Decrease " + $pname + " Quantity");
  });

  $(".space-y-double-section-vertical-spacing .section-content").each(function () {
    $(this).find(".section-content-top-margin ul li").each(function () {
      const $text = $(this).find(".product-tile h3").text().trim();
      const $a_btn = $(this).find("button[data-tc-qty-plus]");
      const $pInput = $(this).find("input.tc-qty-input");
      const $d_btn = $(this).find("button[data-tc-qty-minus]");

      $a_btn.attr("aria-label", "Increase " + $text + " Quantity");
      $pInput.attr("aria-label", $text + " Quantity");
      $d_btn.attr("aria-label", "Decrease " + $text + " Quantity");
    });
  });

  $("ul.grid.gap-theme.grid-cols-2").each(function () {
    $(this).find("li").each(function () {
      const $text = $(this).find("h3.font-body.text-base").text().trim();
      const $a_btn = $(this).find("button[data-tc-qty-plus]");
      const $pInput = $(this).find("input.tc-qty-input");
      const $d_btn = $(this).find("button[data-tc-qty-minus]");

      $a_btn.attr("aria-label", "Increase " + $text + " Quantity");
      $pInput.attr("aria-label", $text + " Quantity");
      $d_btn.attr("aria-label", "Decrease " + $text + " Quantity");
    });
  });

  $("ul.grid.gap-theme.grid-cols-1").each(function(){
    $(this).find("li").each(function () {
      const $text = $(this).find("h3.font-body.text-base").text().trim();
      const $select = $(this).find("select");
      $select.attr("aria-label", $text);
    });
  });
$('.product-container-main.section-content .product-content s.text-scheme-text').each(function () {
  const $el = $(this);
  $el.attr('aria-hidden', 'true');
  if (!$el.next().hasClass('sr-only')) {
    $('<span class="sr-only">' + $el.text().trim() + '</span>')
      .insertAfter($el);}});
$('.product-container-main.section-content .product-content').each(function () {
  $(this).find('s.text-scheme-text').prev('.sr-only')
    .text('Regular price');
  $(this).find('[data-product-price]').prev('.sr-only')
    .text('Sale price');});

//     setTimeout(function () {
// $('.product-container-main .product-media ul.feature-media-list,.product-container-main .product-media ul.feature-media-list li').attr('role','presentation');
//   new MutationObserver(() => {
//   $('.product-container-main .product-media ul li a').removeAttr('aria-current');
//   $('.product-container-main .product-media ul li.product-thumbnail-list-item--active a')
//     .attr('aria-current','true');
// }).observe(
//   document.querySelector('.product-container-main .product-media ul'),
//   { subtree: true, attributes: true, attributeFilter: ['class'] }
// );
//   }, 1500);
// setTimeout(function () {
//   $('.product-container-main .product-media ul.feature-media-list, .product-container-main .product-media ul.feature-media-list li')
//     .attr('role', 'presentation');
//   const mediaList = document.querySelector('.product-container-main .product-media ul');
//   if (!mediaList) return;
//   new MutationObserver(() => {
//     $('.product-container-main .product-media ul li a').removeAttr('aria-current');

//     $('.product-container-main .product-media ul li.product-thumbnail-list-item--active a')
//       .attr('aria-current', 'true');
//   }).observe(mediaList, {
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['class']
//   });
// }, 1500);

$('button.splide__arrow--prev span img,button.splide__arrow--next span img').attr('alt','');
$('#template--26411594055999__image_with_text_alternative_VEtc8L h6.highlight-text')
  .attr('aria-hidden','true')
  .each(function () {
    if (!$(this).next().hasClass('sr-only')) {
      $(this).after('<h6 class="sr-only">' + $(this).text().trim() + '</h6>');}});
$('.newsletter-form-container form.contact-form')
  .find('#name-label').attr('autocomplete','given-name').end()
  .find('#phone-number-label').attr('autocomplete','tel').end()
  .find('#email-label').attr('autocomplete','email');
$('.product-container-main .product-content h2.product-subtitle').attr('role','none');

new MutationObserver(() => {
  document.querySelectorAll('img[src*="talitha-badge-logo"]')
    .forEach(img => img.alt = 'Talitha Coffee Hope Roasted');
}).observe(document.body, { childList: true, subtree: true });

  setInterval(function () {
    $(".collection-tab-panel .splide__track").removeAttr("aria-live").removeAttr("aria-atomic").removeAttr("aria-busy");
    $(".oke-state-empty-button a").attr("aria-label", "Write a review");
    $(".oke-w-panel").removeAttr("role").removeAttr("aria-label");
    $('#template--26411594055999__image_with_text_alternative_VEtc8L img').attr('alt','');
    $('#shopify-section-template--25396251164991__9770567a-44d1-4f41-bb9a-d3001ca9fff0 img,#shopify-section-template--25396251164991__f33e2f71-5967-49bd-b058-d41aa77a8eb0 img,#shopify-section-template--25396251164991__1e5bf31f-76f3-488e-a2a7-687e7ca4dfa3 img,#shopify-section-template--25396251164991__14528820-54c0-40da-b52e-157fd83f8a8a img').attr('alt','');
    if ($('body').hasClass('page-about')) {
    document.title = 'Discover Talitha Coffee: Quality with Purpose - Talitha Coffee';
  }
    $(".oke-avatar").each(function () {
    const $user = $(this).find(".oke-avatar-placeholder").text().trim();
    $(this).attr({
      role: "img",
      "aria-label": $user
    });
    });
        $('#rebuy-cart h4.primary-title,#rebuy-cart a.rebuy-cart__flyout-item-product-title,#rebuy-cart h5.rebuy-product-title.clickable').attr({'role':'heading','aria-level':'2'});
    $(".rebuy-cart__progress-bar-meter .rebuy-cart__progress-bar-meter-fill").removeAttr("role").removeAttr("tabindex").removeAttr("aria-labelledby");
    $(".rebuy-cart__flyout-item-variant-title").removeAttr("tabindex");
    $(".rebuy-money span").removeAttr("tabindex");
    $("h6#SmartCart_title").attr({
      role: "heading",
      "aria-level": "2"
    });
    $(" .splide__list .rebuy-product-block button.rebuy-button").removeAttr("tabindex");
    $(".rebuy-cart__flyout-empty-cart h4").attr({
      role: "heading",
      "aria-level": "3"
    });

    $("h1#SmartCart_title,.rc-subscription-details .rc-tooltip__content .how-it-works strong").attr({
      role: "heading",
      "aria-level": "2"
    });
if (document.body.classList.contains("page-index")) {
  document.title = "Homepage | Talitha Coffee";
}
    $('img[src*="Logo_54d8f879-9a7c-4e7e-97f8-8b447a278480.svg"]').attr("alt", "Talitha Coffee Hope Rosted Get 10% Off");
    $("#slideshow-template--26411595661631__524a80b0-f537-4729-8e03-2951f3996a4c--track").removeAttr("aria-atomic").removeAttr("aria-live");
    $("#slideshow-template--26411595465023__06068412-08a1-4100-8bc0-0839d1dd27ec--track").removeAttr("aria-atomic").removeAttr("aria-live");
    $("#slideshow-template--26411595891007__f92a3d3e-9291-403f-846d-5c2f3a85fff7--track").removeAttr("aria-atomic").removeAttr("aria-live");

    $("span.err").attr("role", "alert");
    $(".message.success .content").attr("role", "alert");

  }, 1000);

  $('body').keydown(function (event) {
    if (event.key == 'Escape') {
      document.body.classList.add('prevent-tooltips');
    }
  });
  $('body').mousemove(function (event) {
    document.body.classList.remove('prevent-tooltips');
  });

  $(".marquee__track a.marquee__item").attr({
    tabindex: "-1",
    role: "none"
  });

new MutationObserver(() => {
  document
    .querySelectorAll('.product-container-main .product-media ul.feature-media-list')
    .forEach(el => el.setAttribute('role', 'none'));
}).observe(document.body, { childList: true, subtree: true });
  $('a').filter(function () {
    return $.trim($(this).text()) === '' && $(this).children().length === 0;
  }).remove();

  const $checkbox = $('#offCheck');
  const $label = $('.offCheckLable');
  $label.attr('tabindex', '0');
  $label.on('click', function () {
    $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
  });
  $label.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
    }
  });
  $label.on('focus', function () {
    $checkbox.focus();
  });

  $(".instafeed-new-layout-wrapper .instafeed-new-layout-item").each(function(index){
    const $div = $(this).find(".instafeed-new-layout-item-container");
    $div.attr("aria-label", "View Instagram post number " + (index + 1) + " opens in a popup");
  });

  $(".right-menu li a.has-children").removeAttr("aria-expanded");


new MutationObserver(() =>
  document.querySelectorAll('img[src*="348424355_926019662040956"]')
    .forEach(img => img.alt = 'Talitha Coffee Hope Roasted')
).observe(document.body, { childList: true, subtree: true });
setTimeout(() => {
  if (location.pathname === '/pages/about') {
    document.title = 'About Talitha - Talitha Coffee';
  }
  $('.rc-subscription-details a.recharge-badge').attr('aria-label','powered by recharge');
}, 3000);
new MutationObserver(() => {
  $('.featured-collection .splide__track.splide__track--loop')
    .removeAttr('aria-atomic');
  $('.featured-collection .product-tile.break-words div.hidden,.featured-collection .product-tile.break-words small.hidden')
    .attr('aria-hidden','true');  
}).observe(document.body, { childList: true, subtree: true });
// 
  $('img[src*="Jenny.png"]').attr("alt", "Testimonial praising Talitha Coffee for staff training and consistently fresh, high-quality coffee, from Jenny G., Beach Plum Kitchen.");

  $('img[src*="Talitha_partner_logos.png"]').attr("alt", "Logos of partner organizations including International Justice Mission, Agape International Missions, GRACE, and others");
  $('img[src*="Talitha_partner_logos.png"]').after('<p class="sr-only">Justice 180 logo, aim  agape intl missions, IJM logo, Grace girls rising above child exploitation, the modern domestic women logo, FBA logo, treasures logo, alabaster jar project logo, love never fails logo, the modern domestic women logo, alabaster jar project, 1902 PLNU logo, center for justice and reconciliation logo, Grace girls rising above child exploitation, the modern domestic women logo, san diego youth service logo, strings for hope logo, 21 logo, rebecca bender initiative logo, clarishealth tm logo, 21 logo, unbound now logo.</p>');

  $('.splide__track ul li.splide__slide div[x-show="hover"] img').attr("alt", "");
  console.log('ally end');
});

new MutationObserver(() => {
  document.querySelectorAll('.page-product [data-color-scheme="primary"] div.font-heading.break-words')
    .forEach(el => el.removeAttribute('role') || el.removeAttribute('aria-level'));
}).observe(document.body, { childList: true, subtree: true });
$(document).ready(function () {
  console.log("a11y ready start");

  const $tabs = $('.collection-tab');

  $('.collection-tabs').attr('role', 'tablist');

  $tabs.each(function () {
    $(this).attr({
      role: 'tab',
      'aria-selected': $(this).hasClass('is-active') ? 'true' : 'false'
    });
  });

  $tabs.on('click', function () {
    const $this = $(this);

    $tabs.removeClass('is-active').attr('aria-selected', 'false');

    $this.addClass('is-active')
      .attr('aria-selected', 'true')
      .focus();

    const target = $this.data('collection');

    $('.collection-content').hide();
    $('#' + target).show();
  });

  $tabs.on('keydown', function (e) {
    let index = $tabs.index(this);

    if (e.key === 'ArrowRight') {
      index = (index + 1) % $tabs.length;
      $tabs.eq(index).focus().click();
    }

    if (e.key === 'ArrowLeft') {
      index = (index - 1 + $tabs.length) % $tabs.length;
      $tabs.eq(index).focus().click();
    }
  });

new MutationObserver(() => {
  const s = document.querySelector('#shop-js-analytics');
  if (s && !document.body.classList.contains('page-added')) {
    const data = JSON.parse(s.textContent);

    document.body.classList.add(
      data.pageType === 'page'
        ? 'page-' + location.pathname.split('/').pop()
        : 'page-' + data.pageType
    );

    document.body.classList.add('page-added');
  }
}).observe(document, { childList: true, subtree: true });

  $("<div>", {
    id: "sr-announcer",
    "aria-live": "polite",
    "aria-atomic": "true",
    role: "alert",
    style: "position:absolute; left:-9999px; height:1px; width:1px; overflow:hidden;"
  }).appendTo("body");

  function announce(message) {
    const $announcer = $("#sr-announcer");
    $announcer.text("");

    setTimeout(() => {
      $announcer.text(message);
    }, 50);
  }

  function bindAnnounce(selector, message) {
    $(selector).on("click keydown", function (e) {
      if (
        e.type === "click" ||
        (e.type === "keydown" && (e.key === "Enter" || e.key === " "))
      ) {
        announce(message);
        console.log("Button hit");
      }
    });
  }

  setTimeout(function(){
    $("button.tc-qty-btn").on("click", function () {

    const $wrapper = $(this).closest("[data-tc-qty]");
    const $input = $wrapper.find(".tc-qty-input");

    setTimeout(function () {
      const qty = $input.val();
      announce("Quantity changed to " + qty);
    }, 100);

  });
  }, 1000);
  bindAnnounce(".controls button.splide__arrow, button.ecom-swiper-button", "Slide changed");
  bindAnnounce(".tc-add-btn", "Added");
  bindAnnounce("button.quantity.decrease-quantity-btn", "Quantity Decreased");
  bindAnnounce("button.quantity.increase-quantity-btn", "Quantity Increased");
  bindAnnounce("ul.gap-gutter .max-w-min .items-stretch button.qty-Decrease", "Quantity Decreased");
  bindAnnounce("ul.gap-gutter .max-w-min .items-stretch button.qty-Increase", "Quantity Increased");

  $('.tc-qty').each(function () {
    const $container = $(this);
    const $input = $container.find('.tc-qty-input');
    const $minus = $container.find('[data-tc-qty-minus]');
    const $plus = $container.find('[data-tc-qty-plus]');
    function updateMinusState() {
      const value = parseInt($input.val(), 10) || 1;
      if (value <= 1) {
        $minus.prop('disabled', true)
          .attr('tabindex', '-1')
          .attr('aria-disabled', 'true');
      } else {
        $minus.prop('disabled', false)
          .attr('tabindex', '0')
          .attr('aria-disabled', 'false');
      }
    }
    updateMinusState();
    $minus.off('click.tcQty');
    $plus.off('click.tcQty');
    $minus.on('click.tcQty', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let value = parseInt($input.val(), 10) || 1;
      if (value > 1) {
        $input.val(value - 1).trigger('change');
      }
    });
    $plus.on('click.tcQty', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let value = parseInt($input.val(), 10) || 1;
      $input.val(value + 1).trigger('change');
    });
    $input.on('input change', updateMinusState);
    const observer = new MutationObserver(updateMinusState);
    observer.observe($input[0], {
      attributes: true,
      attributeFilter: ['value']
    });
  });

  const $container = $('.input');
  const $inputNumber = $container.find('input[type="number"]');
  const $minusBtn = $container.find('button[aria-label="Decrease"]');
  function updateButtonState() {
    let val = parseInt($inputNumber.val(), 10) || 0;
    if (val <= 1) {
      $minusBtn.prop('disabled', true);
      $minusBtn.attr('tabindex', '-1');
      $minusBtn.css('opacity', '0.5');
    } else {
      $minusBtn.prop('disabled', false);
      $minusBtn.removeAttr('tabindex');
      $minusBtn.css('opacity', '1');
    }
  }
  updateButtonState();
  const observer = new MutationObserver(function () {
    updateButtonState();
  });
  if ($inputNumber.length) {
  observer.observe($inputNumber[0], {
    attributes: true,
    attributeFilter: ['value']
  });
}
  $inputNumber.on('input change keyup', function () {
    updateButtonState();
  });


  $(document).on("click touchstart", ".rc-subscription-details__button", function(e) {
    const $btn = $(this);
    const expanded = $btn.attr("aria-expanded") === "true";

    $btn.attr("aria-expanded", !expanded);
    $(".rc-tooltip").toggle(!expanded);

    if (expanded) {
        $btn.blur();
    }
  });

$('form#create_customer').each(function () {
  $(this).prepend('<div class="required_message">Fields marked with * are required.</div>');
});
$('form#create_customer label[for="first_name"]').text("First Name *");
$('form#create_customer label[for="email"]').text("Email Address *");
$('form#create_customer label[for="password"]').text("Password *");
$('form#ContactForm label[for="ContactFormName"]').text("Name *");
$('form#ContactForm label[for="ContactFormEmail"]').text("Email *");
$('form#ContactForm label[for="ContactFormPhone"]').text("Phone Number *");
// $("#ContactForm").attr("novalidate", true);
// $("form.contact-form").attr("novalidate", true);

    var $form = $('.contact-form');
    $form.find('input[type="text"], input[type="tel"], input[type="email"]').each(function () {
        if (!$(this).next('.field-error').length) {
            $(this).after('<div class="field-error" style="color:#d93025;font-size:14px;margin-top:4px;"></div>');
        }
    });
    function validateField($field) {
        var value = $.trim($field.val());
        var error = '';
        var type = $field.attr('type');
        if ($field.prop('required') && value === '') {
            if (type === 'text') {
                error = 'Please enter your name';
            } else if (type === 'tel') {
                error = 'Please enter phone number';
            } else if (type === 'email') {
                error = 'Please enter email address';
            }
        } else if (type === 'tel') {
            var phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(value)) {
                error = 'Phone number must contain 10 digits';
            }
        } else if (type === 'email') {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                error = 'Please enter a valid email address';
            }
        }
        $field.next('.field-error').text(error);
        if (error) {
            $field.attr('aria-invalid', 'true');
            return false;
        }
        $field.removeAttr('aria-invalid');
        return true;
    }

    $form.on('blur input', 'input', function () {
        validateField($(this));
    });

    $form.on('submit', function (e) {
        var isValid = true;
        var firstInvalidField = null;
        $form.find('input[type="text"], input[type="tel"], input[type="email"]').each(function () {
            var valid = validateField($(this));
            if (!valid && !firstInvalidField) {
                firstInvalidField = $(this);
                isValid = false;
            }
        });
        if (!isValid) {
            e.preventDefault();
            firstInvalidField.focus();
            $('html, body').animate({
                scrollTop: firstInvalidField.offset().top - 100
            }, 300);
        }
    });


    $("#ContactForm").attr("novalidate", true);

    $("#ContactForm").on("submit", function (e) {

        let isValid = true;

        $(".error-message").remove();

        const name = $("#ContactFormName").val().trim();
        const email = $("#ContactFormEmail").val().trim();
        const phone = $("#ContactFormPhone").val().trim();
        const message = $("#ContactFormMessage").val().trim();

        // Name
        if (name === "") {
            $("#ContactFormName").after('<span class="error-message">Please enter your name.</span>');
            isValid = false;
        }

        // Email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email === "") {
            $("#ContactFormEmail").after('<span class="error-message">Please enter your email.</span>');
            isValid = false;
        } else if (!emailRegex.test(email)) {
            $("#ContactFormEmail").after('<span class="error-message">Please enter a valid email address.</span>');
            isValid = false;
        }

        // Phone
        const phoneRegex = /^[0-9]{10}$/;
        if (phone === "") {
            $("#ContactFormPhone").after('<span class="error-message">Please enter your phone number.</span>');
            isValid = false;
        } else if (!phoneRegex.test(phone)) {
            $("#ContactFormPhone").after('<span class="error-message">Please enter a valid 10-digit phone number.</span>');
            isValid = false;
        }

        // Message
        if (message === "") {
            $("#ContactFormMessage").after('<span class="error-message">Please enter your message.</span>');
            isValid = false;
        }

        if (!isValid) {
            e.preventDefault();
        }
    });

    // Remove error on typing
    $("#ContactForm input, #ContactForm textarea").on("input", function () {
        $(this).next(".error-message").remove();
    });

$("#slideshow-template--26411593531711__aac0e69b-0cf2-4c43-bb45-6c8dfc204084 button.splide__arrow").prop("disabled", true);

$('img[src*="Group_-_1_of_15.png"]').attr("alt", "Plenty of seating to enjoy your brunch");
$('img[src*="Group_-_1_of_16.png"]').attr("alt", "Robutst food menu");
$('img[src*="Group_-_1_of_12.png"]').attr("alt", "Outdoor tables for slow morning");
$('img[src*="Group_-_1_of_14.png"]').attr("alt", "Easygoing service with baristat that know the neighbourhood");
$('img[src*="Group_-_1_of_13.png"]').attr("alt", "WIFI friendly space for work or reading");

$('img[src*="liberty_station_blue_card.png"]').attr("alt", "A welcoming walk-up counter that keeps you in the flow of the market");
$('img[src*="liberty_station_orange.png"]').attr("alt", "Right in the heart of liberty public market, so you can grab coffee and explore local vendors in one trip.");
$('img[src*="liberty_station_red_card.png"]').attr("alt", "A place where freelancers, families, and tourists all feel equally at home");
$('img[src*="liberty_station_yellow_card.png"]').attr("alt", "Speciality coffee and organic beans, roasted with intentions we are particular about this");

$('.phone-number img[src*="Vector.svg"]').attr("alt", "Phone");
$('img[src*="RT_OrganicFourColorOrganicSeal.webp"]').attr("alt", "USDA organic registered logo");

$('#shopify-block-AUmszMGkrTmpscTVyL__ai_gen_block_b427614_TKphTk iframe').attr("aria-label", "Google maps");


$('#ContactForm').on('submit', function (e) {

        e.preventDefault();
        e.stopImmediatePropagation();

        var form = this;
        var firstError = null;

        $('.error-field').removeClass('error-field');

        // Name
        var $name = $('#ContactFormName');
        if ($.trim($name.val()) === '') {
            $name.addClass('error-field');
            firstError = firstError || $name;
        }

        // Email
        var $email = $('#ContactFormEmail');
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if ($.trim($email.val()) === '' || !emailRegex.test($email.val())) {
            $email.addClass('error-field');
            firstError = firstError || $email;
        }

        // Phone
        var $phone = $('#ContactFormPhone');
        if ($.trim($phone.val()) === '') {
            $phone.addClass('error-field');
            firstError = firstError || $phone;
        }

        // Message
        var $message = $('#ContactFormMessage');
        if ($.trim($message.val()) === '') {
            $message.addClass('error-field');
            firstError = firstError || $message;
        }

        if (firstError) {
            $('html, body').animate({
                scrollTop: firstError.offset().top - 100
            }, 300);

            firstError.focus();

            return false;
        }

        // Submit only when valid
        form.submit();
});

$(".bh-section-wrapper h2.bh-title").attr({
  role: "heading",
  "aria-level": "1"
});

$("section.text-scheme-text ul.grid-container-custom").attr("role", "none");

$('img[src*="background1.jpg"]').attr("alt", "");

function toggleMinusButton($wrapper) {
    const value = parseInt($wrapper.find('input[type="number"]').val(), 10) || 1;
    const $minusBtn = $wrapper.find('.qty-Decrease');
    if (value <= 1) {
      $minusBtn.attr('disabled', true).attr('aria-disabled', 'true');
    } else {
      $minusBtn.removeAttr('disabled').removeAttr('aria-disabled');
    }
  }
  $('.max-w-min').each(function () {
    toggleMinusButton($(this));
});
$(document).on('input change', '.max-w-min input[type="number"]', function () {
  toggleMinusButton($(this).closest('.max-w-min'));
});

if (!$('.hero-section .hero-video-toggle').length) {
    $('.hero-section .splide__arrows').prepend(`
      <button
        type="button"
        class="hero-video-toggle push-btn"
        aria-label="Pause video"
        aria-pressed="false"
      >
        Pause
      </button>
    `);
}
$(document).on('click', '.hero-video-toggle', function () {
    const video = document.querySelector(
      '.splide__slide video'
    );

    if (!video) return;

    if (video.paused) {
      video.play();
      $(this)
        .text('Pause')
        .attr({
          'aria-label': 'Pause video',
          'aria-pressed': 'false'
        });
    } else {
      video.pause();
      $(this)
        .text('Play')
        .attr({
          'aria-label': 'Play video',
          'aria-pressed': 'true'
        });
    }
});

// if (!$('.full-bleed-section').length) {
//     $('.full-bleed-section').prepend(`
//       <button
//         type="button"
//         class="hero-video-toggle push-btn"
//         aria-label="Pause video"
//         aria-pressed="false"
//       >
//         Pause
//       </button>
//     `);
// }
// $(document).on('click', '.hero-video-toggle', function () {
//     const video = document.querySelector(
//       '.splide__slide video'
//     );

//     if (!video) return;

//     if (video.paused) {
//       video.play();
//       $(this)
//         .text('Pause')
//         .attr({
//           'aria-label': 'Pause video',
//           'aria-pressed': 'false'
//         });
//     } else {
//       video.pause();
//       $(this)
//         .text('Play')
//         .attr({
//           'aria-label': 'Play video',
//           'aria-pressed': 'true'
//         });
//     }
// });

//  const $section = $('[x-data="ThemeModule_BackgroundVideo"]');
//   const $video = $section.find('video');

//   if (!$section.length || !$video.length) return;

//   const playIcon = `
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//       <path d="M8 5v14l11-7z"></path>
//     </svg>
//   `;

//   const pauseIcon = `
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//       <path d="M6 5h4v14H6zm8 0h4v14h-4z"></path>
//     </svg>
//   `;

//   const $btn = $(`
//     <button
//       type="button"
//       class="video-toggle-btn"
//       aria-label="Pause video"
//       aria-pressed="false"
//     >
//       ${pauseIcon}
//     </button>
//   `);

//   $section.append($btn);

//   function updateButton() {
//     if ($video[0].paused) {
//       $btn.html(playIcon);
//       $btn.attr('aria-label', 'Play video');
//       $btn.attr('aria-pressed', 'true');
//     } else {
//       $btn.html(pauseIcon);
//       $btn.attr('aria-label', 'Pause video');
//       $btn.attr('aria-pressed', 'false');
//     }
//   }

//   $btn.on('click', function () {
//     const video = $video[0];

//     if (video.paused) {
//       video.play();
//     } else {
//       video.pause();
//     }

//     updateButton();
//   });

//   $video.on('play pause', updateButton);

//   updateButton();

console.log("a11y ready end");
});